 import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
 import skills from "../skill"

 const DisplaySkills = () => {

    return skills().map((skill, index) => {
      return (
        <div key={index} className="panel-icon">
          <FontAwesomeIcon icon={skill.icon} size="3x" />
          <p>{skill.name}</p>
        </div>
      );
    });
  };

  export default DisplaySkills